import { AfterContentChecked, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { BenefitEnrollmentButtonList, IBenefitEnrollmentButton } from "src/app/constants/benefit-enrollment-button";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { BenefitSummaryList } from "src/app/models/benefit-summary";
import { BenefitComparisonList, EnrollmentCategoryOptions } from "src/app/models/enrollment-option";
import { TableColumn, MatTableLoad } from "src/app/models/table";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-benefit-enrollment-category',
    templateUrl: './category.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenefitEnrollmentCategoryComponent implements AfterContentChecked, OnInit {
    @Input() public enrollmentCategoryOptions: EnrollmentCategoryOptions;
    @Input() public benefitSummaryList: BenefitSummaryList;
    @Input() public displayResourcesButton: boolean;
    @Input() public toggleCategoryIntroduction: boolean;
    @Input() public isEnrollmentMode: boolean;

    @Output() public selectWizardEmit: EventEmitter<BenefitWizardType> = new EventEmitter();
    @Output() public categoryResourcesSelectedEmit: EventEmitter<any> = new EventEmitter();
    @Output() public nextCategorySelectedEmit: EventEmitter<any> = new EventEmitter();

    public availableBenefitsMatTableData: MatTableDataSource<any>;
    public availableBenefitsColumns: TableColumn[];
    public availableBenefitsButtons: IBenefitEnrollmentButton[];
    public currentBenefitButtons: IBenefitEnrollmentButton[];
    public displayCategoryHTML: boolean;
    
    constructor(
        private helperService: HelperService,
        public enrollmentManagerService: EnrollmentManagerService,
    ){
    }

    ngOnInit(): void {
        let l_FilterdList: any[] = [];
        this.enrollmentCategoryOptions.benefitCompareModel[0].benefitCompareList.forEach((bcl: any) => {
            if (bcl['Attribute'])
                l_FilterdList.push(bcl);
        });
        const l_MatTableLoad: MatTableLoad = this.helperService.convertTableRowsToColumns(l_FilterdList, true);
        this.availableBenefitsMatTableData = new MatTableDataSource<BenefitComparisonList>();
        l_MatTableLoad.tableColumns[0].columnName = 'Benefit Name';
        this.availableBenefitsColumns = l_MatTableLoad.tableColumns;
        this.availableBenefitsMatTableData.data = l_MatTableLoad.data;
 
        BenefitEnrollmentButtonList.forEach((bebl: IBenefitEnrollmentButton) => {
            if (this.enrollmentCategoryOptions[bebl.activatePropName as keyof EnrollmentCategoryOptions]) {
                if (bebl.isCurrentBenefitSection) {
                    if (!this.currentBenefitButtons)
                        this.currentBenefitButtons = new Array<IBenefitEnrollmentButton>;

                    this.currentBenefitButtons.push(bebl);
                } else {
                    if (!this.availableBenefitsButtons)
                        this.availableBenefitsButtons = new Array<IBenefitEnrollmentButton>;

                    this.availableBenefitsButtons.push(bebl);
                }
            }
        });

        if (this.enrollmentManagerService.cancelHideIntro) {
            this.displayCategoryHTML = false;
            this.enrollmentManagerService.cancelHideIntro = false;
        } else {
            this.displayCategoryHTML = this.enrollmentCategoryOptions.isHTMLAvailable;
        }
        
    }

    ngAfterContentChecked(): void {
        if (this.enrollmentManagerService.cancelHideIntro) {
            this.displayCategoryHTML = false;
            this.enrollmentManagerService.cancelHideIntro = false;
        } else if (!this.displayCategoryHTML && this.toggleCategoryIntroduction) {
            this.displayCategoryHTML = true;
        }
    }

    public continueToForm(): void {
        this.displayCategoryHTML = false;
        this.toggleCategoryIntroduction = false;
    }

    public selectWizard(managerButton: IBenefitEnrollmentButton): void {
        this.selectWizardEmit.emit(managerButton.BenefitWizardType);
    }

    public resourcesSelected(): void {
        this.categoryResourcesSelectedEmit.emit();
    }

    public nextCategorySelected(): void {
        this.nextCategorySelectedEmit.emit();
    }
}